const RTL_LOCALES = ['ar-AE'];

export default defineNuxtPlugin(() => {
  const { locale } = useNuxtApp().$i18n;

  function applyDirection(loc: string) {
    const dir = RTL_LOCALES.includes(loc) ? 'rtl' : 'ltr';
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', loc);
  }

  applyDirection(locale.value);

  watch(locale, (newLocale) => {
    applyDirection(newLocale);
  });
});
